var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dropdownPaymentWhtPnd"}},[_c('DropdownComponent',{attrs:{"label":"แบบ ภ.ง.ด. ที่หัก","trackBy":"value","options":_vm.options,"selected":_vm.selectedPnd,"search":false},on:{"update:selected":function($event){_vm.selectedPnd=$event}},scopedSlots:_vm._u([{key:"selected",fn:function(ref){
var props = ref.props;
return [_c('p',[_vm._v(_vm._s(props.name))])]}},{key:"options",fn:function(ref){
var props = ref.props;
return [_c('p',[_vm._v(_vm._s(props.name))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }